import React from 'react'
import Header from './header/Header'
import List from './work/list/List'
import About from './about/About'
import Contact from './contact/Contact'
import ReactGA from 'react-ga'



export default class App extends React.Component {
  render() {
    const data = require('../assets/data.js')
    return (
      <div>
        <Header/>
        <List projects={data.projects}/>
        <About profile={data.profile}/>
        <Contact email={data.email}/>
      </div>
    )
  }
}

ReactGA.initialize('UA-46400607-2')
ReactGA.pageview('start')



// WEBPACK FOOTER //
// ./src/components/App.js